export const LOGOUT = "AUTH/LOGOFF";
export const SET_TOKEN = "AUTH/SET_DATA";
export const LOAD_PERMISSIONS = "AUTH/LOAD_PERMISSIONS";
export const SET_PERMISSIONS = "AUTH/SET_PERMISSIONS";
export const RESET = "AUTH/RESET";
